import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder,FormGroup, FormControl,Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import{UserService} from '../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

declare var $:any;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  resetFormGroup:FormGroup;
  group:Object={};
  token:any='';
  loader_image:boolean=false;
  tokenValid:boolean=false;
  tokenChecked:boolean=false;
  passPattern="^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!@#$%^&*]).{8,}$";
  @ViewChild('pwdInput', { static: false }) pwdInput: ElementRef;
  @ViewChild('confirmInput', { static: false }) confirmInput: ElementRef;
  showPassword: boolean = false;
  showConfirm: boolean = false;

  constructor(private _router: Router,private toastr: ToastrService,private route: ActivatedRoute,private _authService: AuthService,private userService:UserService,private formBuilder: FormBuilder) {


  }

  ngOnInit() {

    this.group['password']=new FormControl('',[Validators.required, Validators.pattern(this.passPattern)]);
    this.group['confirm']=new FormControl('',[Validators.required]);

    this.resetFormGroup =  this.formBuilder.group(this.group);

    this.token = this.route.snapshot.queryParams['token'] || '';

    this.validateToken();

  }

  validateToken(){

    if(!this.token){
      this.tokenChecked=true;
      this.tokenValid=false;
      return;
    }

    let data={
      validate_reset_token:true,
      token:this.token
    }

    this.loader_image=true;

    this.userService.getUserList(data).subscribe( (res)=>{

      this.loader_image=false;
      this.tokenChecked=true;

      if(res.status=='success'){
        this.tokenValid=true;
      }else{
        this.tokenValid=false;
      }

    }, (err)=>{
      this.loader_image=false;
      this.tokenChecked=true;
      this.tokenValid=false;
    });

  }

  ngAfterViewInit(): void {

    $(document).ready(function(){
      $('input').blur(function(event) {
        var inputValue = this.value;
        if (inputValue) {
          this.classList.add('value-exists');
        } else {
          this.classList.remove('value-exists');
        }
      });
    });
    // Password show/hide is handled by Angular click handlers (togglePassword / toggleConfirmPassword)

  }

  togglePassword(){
    this.showPassword = !this.showPassword;
    try{
      if(this.pwdInput && this.pwdInput.nativeElement){
        this.pwdInput.nativeElement.type = this.showPassword ? 'text' : 'password';
      }
    }catch(e){ }
  }

  toggleConfirmPassword(){
    this.showConfirm = !this.showConfirm;
    try{
      if(this.confirmInput && this.confirmInput.nativeElement){
        this.confirmInput.nativeElement.type = this.showConfirm ? 'text' : 'password';
      }
    }catch(e){ }
  }

  reset() {

    if(this.resetFormGroup.status =='VALID'){

      if(this.resetFormGroup.value['password']!=this.resetFormGroup.value['confirm']){
        this.toastr.error('Please enter same value for password and confirm password', '', {timeOut: 3000});
        return;
      }

      let data={
        set_password:true,
        token:this.token,
        password:this.resetFormGroup.value['password'],
        confirm:this.resetFormGroup.value['confirm']
      }

      this.loader_image=true;

      this.userService.getUserList(data).subscribe( (res)=>{

        this.loader_image=false;

        if(res.status=='success'){

          this.toastr.success('Your password has been reset. Please login with your new password.', '', {timeOut: 3000});
          this._router.navigate(['/vlogin']);

        } else{

          this.toastr.error(res.message || 'Unable to reset your password. The link may have expired.', '', {timeOut: 3000});

        }

      }, (err)=>{
        this.loader_image=false;
        this.toastr.error('Unable to reset your password. Please try again.', '', {timeOut: 3000});
      });

    }else{

      this.checkInput();
    }

  }

  checkInput(){

    if(this.resetFormGroup.controls['password'].status=="INVALID"){

      this.toastr.error('Password field should be minimum 8 characters containing lowercase, uppercase, number and special characters', '', {timeOut: 3000});

    }else if(this.resetFormGroup.controls['confirm'].status=="INVALID"){

      this.toastr.error('Confirm Password field required', '', {timeOut: 2000});

    }

  }

}
